import React from 'react';
import PropTypes from 'prop-types';
import { Button as ReactUIButton } from 'panamera-react-ui';
import withConfig from 'HOCs/withConfig/withConfig';
import { THEMES } from 'Constants/bundles';

export const Button = ({ config, roundCorners, ...restProps }) => {
    const id = config?.get?.('theme')?.id;

    let hasRoundCorners = roundCorners === undefined ? (id === THEMES.LETGO) : roundCorners;

    // Button should not have rounded corners in case it is a tertiary button
    if (['tertiaryBtn', 'flat'].includes(restProps.type)) {
        hasRoundCorners = false;
    }

    return (
        <ReactUIButton { ...restProps } roundCorners={ !!hasRoundCorners } theme={ id } />
    );
};

Button.propTypes = {
    config: PropTypes.shape({
        get: PropTypes.func
    }).isRequired,
    roundCorners: PropTypes.bool
};

export default withConfig(Button);
